const banner = ``;

export default banner;
